module.exports = __webpack_public_path__ + "static/media/bill3.c7cfc5ab.png";